import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import {
  Button,
  VStack,
  Box,
  Text,
  Link,
  useColorModeValue,
} from '@chakra-ui/react'

import { LOGIN_DEFAULT_REDIRECT, REGISTER_DEFAULT_REDIRECT } from '@/constants'
import { useValidateReturnTo } from '@/hooks/useValidation'

export function Auth0UniversalLogin() {
  const t = useTranslations()
  const { query } = useRouter()

  useValidateReturnTo()

  let returnFromSignIn = query?.return_to || LOGIN_DEFAULT_REDIRECT
  if (query?.tab) {
    returnFromSignIn = `${returnFromSignIn}?tab=${String(query.tab)}`
  }

  let returnFromRegister = query?.return_to || REGISTER_DEFAULT_REDIRECT
  if (query?.tab) {
    returnFromRegister = `${returnFromRegister}?tab=${String(query.tab)}`
  }

  return (
    <VStack spacing="4">
      <Box w="100%">
        <Button
          variant="brandGradient"
          w="100%"
          as={Link}
          href={`/api/auth/login?returnTo=${returnFromSignIn}`}
          _hover={{
            bg: 'brand.50',
            textDecoration: 'none',
            color: 'brand.600',
          }}
        >
          {t('buttons.sign-in')}
        </Button>
      </Box>
      <Text fontSize={{ base: 'xs', sm: 'sm' }}>Or</Text>
      <Box w="100%">
        <Button
          mt={0}
          size="lg"
          w="100%"
          h={'41'}
          as={Link}
          href={`/api/auth/signup?returnTo=${returnFromRegister}`}
          color="black"
          bg={useColorModeValue('gray.100', 'gray.200')}
          _hover={{
            bg: useColorModeValue('gray.200', 'gray.300'),
            color: 'black',
            textDecoration: 'none',
          }}
        >
          {t('buttons.create-account')}
        </Button>
      </Box>
    </VStack>
  )
}
